(function notificationServiceDefinition() {
    'use strict';
    angular.module('Entities')
        .service('notificationService', [
            'restUrlBuilder', function notificationService(restUrlBuilder) {

                var restUrlBuilder = restUrlBuilder('wf');

                this.getTypes = function getTypes() {
                    return restUrlBuilder.all('notificationTypes').get();
                };

                this.getTypesById = function getTypesById(id) {

                    var params = { Id: id };

                    return restUrlBuilder.one('notificationTypes').get({ params: params });
                };

                this.getById = function getById(id) {
                    var params = { Id: id };

                    return restUrlBuilder.one('notifications', id).get();
                };

                this.get = function get(filters) {
                    var params = {
                        notificationTypes: filters.notificationTypes,
                        status: filters.notificationState,
                        creationFrom: filters.notificationDateFrom,
                        creationTo: filters.notificationDateTo,
                        itemPerPage: filters.itemPerPage,
                        page: filters.currentPage
                    };

                    return restUrlBuilder.all('notifications').get({ params: params });
                };

                this.createEmployerCertificateExpirateNotifications = function (params) {

                    if (params == null) {
                        throw "el parametro no puede ser null";
                    }

                    var notifications = [{
                        ProcessId: params.owner, //le pongo el userId para que funcione el enlace
                        OrganizationalUnitId: params.organizationalUnitId,
                        Owner: params.owner,
                        TypeKey: "MailVencimientoCertificadoEmpleador",
                        RunFrom: params.notificationDate,
                        Mail: params.mail,
                        OwnerName: params.ownerName
                    },
                    {
                        ProcessId: params.owner,
                        OrganizationalUnitId: params.organizationalUnitId,
                        Owner: params.owner,
                        RunFrom: params.notificationDate,
                        TypeKey: "HomeVencimientoCertificadoEmpleador",
                        OwnerName: params.ownerName
                    }];

                    return restUrlBuilder.all('notifications/batch').post(notifications);
                };


                this.deleteNotifications = function (ouId) {

                    if (ouId == null) {
                        throw "el parametro no puede ser null";
                    }

                    return restUrlBuilder.one('notifications/deleteprocess', ouId).delete({ params: { all: true } });
                };
            }
        ]);
})();